__turbopack_context__.v({
  "dialog": "ProcedureDetailDialog-module-scss-module__1QsOjG__dialog",
});
